module.exports = __webpack_public_path__ + "static/media/close.5b63e070.png";